// Functional component for the sort icons of the navbar

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faA, faClock, IconDefinition } from "@fortawesome/free-solid-svg-icons";

interface SortIconProps {
    isSelected: boolean,
    icon: Icon,
    clickHandler(icon: Icon): void
}

// Used in navbar component too for which sorting should be used
export enum Icon {
    Character = "character",
    Clock = "clock"
}

const SortIcon = (props: SortIconProps) => {
    // Selected icon is highlighted
    let classNameAppendage = props.isSelected ? "icon--container--selected" : "";
    let faIcon: IconDefinition = props.icon === Icon.Character ? faA : faClock;

    return (
        <div 
            className={`icon--container ${classNameAppendage}`}
            onClick={event => props.clickHandler(props.icon)}
        >
            <FontAwesomeIcon icon={faIcon}/>
        </div>
    )
}

export default SortIcon
